module.exports = __webpack_public_path__ + "img/horizontal_4_7_r_pp23_5.0caae469.png";